import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ShoppingCart } from '../models';

export const ShoppingCartActions = createActionGroup({
  source: 'Medical Shop - ShoppingCart',
  events: {
    'Fetch shopping carts': emptyProps(),
    'Fetch shopping carts success': props<{
      shoppingCarts: Array<ShoppingCart>;
    }>(),
    'Fetch shopping carts error': emptyProps(),
    'Request shopping cart': props<{
      shoppingCartId: string;
    }>(),
    'Request shopping cart success': props<{
      shoppingCartId: string;
      isImmediateApproval: boolean;
    }>(),
    'Request shopping cart error': emptyProps(),
    'Shopping cart update': props<{
      shoppingCartId: string;
      shoppingCart: Partial<ShoppingCart>;
    }>(),
  },
});
